import SEO from '../components/SEO';

function Terms() {
  return (
    <div className="page-terms">
      <SEO title="Terms and Conditions" description="Read the Anthroper terms and conditions. Understand the rules and guidelines for using our website and tools." path="/terms" />
      <div className="container content-page">
        <h1>Terms and Conditions</h1>
        <p className="last-updated">Last updated: March 1, 2026</p>

        <section>
          <h2>Agreement to Terms</h2>
          <p>By accessing and using Anthroper ("the Site"), you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you should not use the Site.</p>
        </section>

        <section>
          <h2>Use of the Site</h2>
          <p>Anthroper provides articles, news analysis, and free online tools for informational and personal use. You may use the Site and its tools for lawful purposes only. You agree not to:</p>
          <ul>
            <li>Use the Site for any illegal or unauthorized purpose.</li>
            <li>Attempt to interfere with the proper functioning of the Site.</li>
            <li>Scrape, copy, or redistribute content from the Site without written permission.</li>
            <li>Use automated systems or bots to access the Site in a manner that exceeds reasonable use.</li>
          </ul>
        </section>

        <section>
          <h2>Intellectual Property</h2>
          <p>All content on the Site, including articles, text, graphics, logos, and software, is the property of Anthroper or its content creators and is protected by copyright and intellectual property laws. You may not reproduce, distribute, or create derivative works from our content without prior written consent.</p>
        </section>

        <section>
          <h2>Tools and Data Processing</h2>
          <p>The online tools provided on the Site process all data locally in your web browser. We do not store, transmit, or have access to any data you enter into our tools. While we strive to ensure our tools function correctly, we provide them "as is" without warranties of any kind. You use the tools at your own risk.</p>
        </section>

        <section>
          <h2>Article Content and Disclaimer</h2>
          <p>Articles published on Anthroper are for informational purposes only. While we strive for accuracy, we do not guarantee that all information is complete, current, or error-free. The views expressed in articles represent analysis and commentary and should not be taken as professional advice.</p>
          <p>Anthroper is an independent publication and is not affiliated with any government, political party, or organization mentioned in our articles.</p>
        </section>

        <section>
          <h2>Third-Party Links</h2>
          <p>The Site may contain links to third-party websites. We are not responsible for the content, privacy practices, or availability of these external sites. Accessing third-party links is at your own risk.</p>
        </section>

        <section>
          <h2>Advertising</h2>
          <p>The Site displays advertisements through Google AdSense. These ads are clearly distinguishable from our editorial content. We do not endorse the products or services advertised on our Site. Ad content is determined by Google based on various factors including your browsing history and preferences.</p>
        </section>

        <section>
          <h2>Limitation of Liability</h2>
          <p>Anthroper and its operators shall not be liable for any direct, indirect, incidental, or consequential damages arising from your use of the Site, its tools, or reliance on any content published on the Site.</p>
        </section>

        <section>
          <h2>Changes to These Terms</h2>
          <p>We reserve the right to update these Terms and Conditions at any time. Changes will be posted on this page with an updated "Last updated" date. Continued use of the Site after changes constitutes acceptance of the revised terms.</p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>If you have any questions about these Terms and Conditions, please contact us at <a href="mailto:akshay.personal.business@gmail.com">akshay.personal.business@gmail.com</a> or through our <a href="/contact">Contact page</a>.</p>
        </section>
      </div>
    </div>
  );
}

export default Terms;
